import { Grid, Typography, Divider } from "@mui/material";
import News from "../components/News";
import ForexChart from "../components/chart";

function MainPage() {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ m: "2%", fontWeight: "bold" }}>
          {" "}
          Foreign Exchange Rate
        </Typography>
        <Divider variant="middle" sx={{ m: "2%" }} />
        <ForexChart />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ m: "2%", fontWeight: "bold" }}>
          {" "}
          News Sentiment Analysis
        </Typography>
        <Divider variant="middle" sx={{ m: "2%" }} />
        <News />
      </Grid>
    </Grid>
  );
}

export default MainPage;
